import { Box, Grid, Typography } from '@mui/material';
import WizardBackButton from 'pages/GettingStarted/Wizard/components/WizardBackLink';
import WizardPrimaryButton from 'pages/GettingStarted/Wizard/components/WizardPrimaryButton';
import WizardSuggestion from 'pages/GettingStarted/Wizard/components/WizardSuggestion';
import WizardContentLayout from 'pages/GettingStarted/Wizard/Phases/WizardContentLayout';
import { WIZARD_PAGES } from 'pages/GettingStarted/Wizard/utils/consts';
import React, { FC } from 'react';
import { IWizardCombination, IWizardProps } from 'types/wizard';
import { useWizardUpdate } from '../../utils/hook';

const Suggestions: FC<IWizardProps> = ({ state }) => {
	const { combinations } = state;

	const { update } = useWizardUpdate(state);
	const [updatedCombinations, setCombinations] = React.useState<
		IWizardCombination[]
	>(combinations || []);

	const handleNext = React.useCallback(() => {
		update({
			page: WIZARD_PAGES.apply,
			combinations: updatedCombinations
		});
	}, [update, updatedCombinations]);

	const handleBack = React.useCallback(() => {
		update({
			page: WIZARD_PAGES.secondaryMethod
		});
	}, [update]);

	const handleClick = React.useCallback(
		(index: number) => () =>
			setCombinations(
				updatedCombinations.map((combination, i) => ({
					...combination,
					selected: i === index
				}))
			),
		[updatedCombinations]
	);

	const hasSelected = React.useMemo(
		() => updatedCombinations.some((combination) => combination.selected),
		[updatedCombinations]
	);

	return (
		<WizardContentLayout
			{...{ state }}
			backButton={<WizardBackButton onClick={handleBack} />}
			actionButton={
				<WizardPrimaryButton disabled={!hasSelected} onClick={handleNext} />
			}
		>
			<Box
				display="flex"
				flexDirection="column"
				flexGrow={1}
				data-testid="wizard-suggestions"
			>
				<Box display="flex" justifyContent="flex-start" flexDirection="column">
					<Typography variant="h6">
						{intl.tr('wizard.phase.build.suggestion.header')}
					</Typography>
					<Typography variant="body1">
						{intl.tr('wizard.phase.build.suggestion.second.header')}
					</Typography>
				</Box>
				<Box pt={4}>
					<Grid container spacing={3}>
						{updatedCombinations.map((item, index) => (
							<Grid
								item
								xs={12}
								md={4}
								key={item.preset}
								flexGrow={1}
								display="flex"
							>
								<WizardSuggestion
									onClick={handleClick(index)}
									combination={item}
								/>
							</Grid>
						))}
					</Grid>
				</Box>
			</Box>
		</WizardContentLayout>
	);
};

export default Suggestions;
